<template>
  <div class="center--bottom">
    <h2 class="f-tac">正常运行设备</h2>
    <dv-scroll-board
      class="center--bottom_tabel"
      ref="scrollBoard"
      :config="dataConfig"
    />
    <!-- <div class="center--bottom_chart" id="centerButtomChart"></div> -->
  </div>
</template>

<script>
import { queryycztsb, queryppsbwhl } from '@/api/modules/dataView.js'
export default {
  name: 'CenterBottom',
  props: {
    date: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
        }
      },
    },
  },
  data() {
    return {
      dataConfig: {},
      chart: null,
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   var chartDom = document.getElementById('centerButtomChart')
    //   this.chart = this.$echarts.init(chartDom)
    //   this.getData()
    // })
    this.getData()
  },
  methods: {
    async getData() {
      // 获取异常状态设备数据
      queryycztsb(this.date).then(data => {
        let dataConfig = {
          rowNum: 6,
          // header: ['医院', '品牌', '设备'],
          // header: ['医院', '设备'],
		  header: ['医院', '设备总数', 'CT', 'MR', '其他'],
		  columnWidth: [350, 100, 100, 100, 100],
          data: [],
        }
        if (data) {
          data.forEach(item => {
            dataConfig.data.push([item.org_name, item.yxsysc_yxsysc, item.ct_count, item.mri_count, item.other_count])
          })
        }
        this.dataConfig = dataConfig
      })
      // 获取品牌设备完好率数据
      const apiData = await queryppsbwhl(this.date)
      let brandData = []
      let data_ct = []
      let data_mri = []
      let data_jsq = []
      apiData.forEach(item => {
        brandData.push(item.brand || '其他')
        data_ct.push(item.CTwhljwx_whl || 0)
        data_mri.push(item.MRIwhljwx_whl || 0)
        data_jsq.push(item.zxjsqwhljwx_whl || 0)
      })
      console.log(data_ct, data_mri, data_jsq)
      var option

      option = {
        title: {
          text: '品牌设备完好率',
          left: 'center',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['CT类', 'MRI类', '直线加速器'],
          top: '30px',
          textStyle: {
            color: '#fff',
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: '#fff',
          },
          boundaryGap: false,
          data: brandData,
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#fff',
          },
        },
        series: [
          {
            type: 'line',
            stack: '总量',
            name: 'CT类',
            data: data_ct,
          },
          {
            type: 'line',
            stack: '总量',
            name: 'MRI类',
            data: data_mri,
          },
          {
            type: 'line',
            stack: '总量',
            name: '直线加速器',
            data: data_jsq,
          },
        ],
      }

      option && this.chart.setOption(option)
    },
  },
}
</script>

<style lang="scss">
.center--bottom {
  width: 100%;
  height: 40%;
  .center--bottom_tabel {
    width: 100%;
    height: 96%;
  }
  // .center--bottom_chart {
  //   margin-top: 10px;
  //   width: 100%;
  //   height: calc(100% - 40% - 30px);
  // }
}

.header-item{
	// width: 146px !important;
}

.row-item{
	// width: 200px !important;
}
</style>
